import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>GET /ams/mediaserver</h1>
        </div>
        <p>**This API endpoint will be changing.</p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>topicid</td>
                <td>The ID of the topic asking for the media server URL</td>
                <td>query</td>
                <td>Yes</td>
                <td>N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authorization</h2>
        <p>None required</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET
          https://spacesapis.avayacloud.com/api/ams/mediaserver?topicid=589b8d81615ff34b2ac2a49b
        </pre>
        <h4>Headers</h4>
        <p>None.</p>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"_id": "589b8d81615ff34b2ac2a49b",{"\n"}
          {"  "}"url": "wcs-production3.onesna.com",{"\n"}
          {"  "}"port": "443",{"\n"}
          {"  "}"siptoken":
          "BEC4780F-E35A-43BC-BDDC-6E62CC1EB59D-CB3AE3C3-416B-404F-A108-BBC6EC0EF190",
          {"\n"}
          {"  "}"sipkey": "91D75F2D-6370-4DC3-B84A-C36CF1AAD0C3",{"\n"}
          {"  "}"ipv4": "104.155.143.49"{"\n"}
          {"}"}
          {"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
